export const getDndKitSortableIndexes = (
  source: unknown,
): { oldIndex: number; newIndex: number } | null => {
  if (!source || typeof source !== "object" || !("sortable" in source)) {
    return null;
  }

  const sortable = (
    source as {
      sortable?: { initialIndex?: unknown; index?: unknown };
    }
  ).sortable;

  if (
    typeof sortable?.initialIndex !== "number" ||
    typeof sortable.index !== "number"
  ) {
    return null;
  }

  return {
    oldIndex: sortable.initialIndex,
    newIndex: sortable.index,
  };
};
